import React from 'react';
import { Link } from 'react-router-dom';

import SectionTitle from '../common/SectionTitle';

const IntegrationTwo = () => {
  return (
    <>
      <section className='integration-section bg-light ptb-120'>
        <div className='container'>
          <div className='row align-items-center justify-content-lg-between'>
            <div className='col-lg-6 col-md-12'>
              <SectionTitle
                subtitle='Integration'
                title='We Collaborate with Top Software Company'
                description='  Dynamically pursue convergence rather than 24/7 process
                  improvements develop end-to-end customer service action items.'
                leftAlign
              />
            </div>
            <div className='col-lg-4 col-md-12'>
              <div className='text-lg-end mb-5 mb-lg-0' data-aos='fade-left'>
                <Link to='/integrations' className='btn btn-primary'>
                  View All Integrations
                </Link>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <div className='integration-wrapper position-relative w-100'>
                <ul className='integration-list list-unstyled mb-0'>
                  <li data-aos='fade-up' data-aos-delay='50'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/airbnb.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='50'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/figma.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='50'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/facebook.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='50'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/sales-force.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='50'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/atlassian.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='50'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/dropbox-2.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='100'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/dynamic-365.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='100'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/erecruiter.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='100'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/evernote.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='100'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/google-icon.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>

                  <li data-aos='fade-up' data-aos-delay='100'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/slack.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>

                  <li data-aos='fade-up' data-aos-delay='100'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/google-analytics.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>

                  <li data-aos='fade-up' data-aos-delay='150'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/google-drive.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>

                  <li data-aos='fade-up' data-aos-delay='150'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/hubspot.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>

                  <li data-aos='fade-up' data-aos-delay='150'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/instagram.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='150'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/linkedin.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='150'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/mailchimp.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                  <li data-aos='fade-up' data-aos-delay='150'>
                    <div className='single-integration'>
                      <img
                        src='assets/img/integations/marekto.png'
                        alt='integration'
                        className='img-fluid'
                      />
                      <h6 className='mb-0 mt-4'>Brand Name</h6>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IntegrationTwo;
